export default __webpack_public_path__ + "static/media/organisation_structure.41ec654a.jpg";